import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "../common/FormDialog";
import FormItem from "../form-item/FormItem";
import UserInfo from "../common/UserInfo";

const PointTopupDialog = ({ open, onClose, onUpdate, user }) => {

  const [form, setForm] = useState({
    type: 'PLUS', // 充值类型
    remark: '',
    amount: '',
  });

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleConfirm() {
    if (Number.isNaN(parseFloat(form.amount))) return alert('数量不能为空');
    
    axios
      .post("/point/change", {
        uid: user.uid,
        ...form,
      })
      .then((res) => {
        const { code, msg, data } = res.data;
        if (code === 1) {
          alert(msg, "success");
          onUpdate();
        } else {
          alert(msg);
        }
      })
      .catch((err) => {
        console.log("topup err: ", err);
      });
  }

  return (
    <FormDialog title="修改积分" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户">
        <UserInfo {...user} />
      </FormItem>

      <FormItem title="变化">
        <RadioGroup row name="row-radio-buttons-group" value={form.type} onChange={(e) => handleIptChange("type", e.target.value)}>
          <FormControlLabel value={'PLUS'} control={<Radio />} label="增加" />
          <FormControlLabel value={'MINUS'} control={<Radio />} label="减少" />
          {/* <FormControlLabel value={'FINAL'} control={<Radio />} label="最终积分" /> */}
        </RadioGroup>
      </FormItem>

      <FormItem title="充值数目">
        <TextField fullWidth type="number" placeholder="充值数目" autoComplete="off" id="amount" 
          value={user.amount} size="small" onChange={(e) => handleIptChange("amount", e.target.value)} />
      </FormItem>

      <FormItem title="备注">
        <TextField fullWidth placeholder="备注" autoComplete="off" id="remark" 
          value={user.remark} size="small" onChange={(e) => handleIptChange("remark", e.target.value)} />
      </FormItem>

    </FormDialog>
  );
};

export default PointTopupDialog;
